import type { ComponentProps } from "react";
import { Platform } from "react-native";
import * as DropdownMenu from "zeego/dropdown-menu";
import { useTheme } from "~/providers/ThemeProvider";

type ItemTitleProps = {
    selected?: boolean;
} & ComponentProps<typeof DropdownMenu.ItemTitle>;

export const DropdownItemTitle = DropdownMenu.create(({ selected, ...props }: ItemTitleProps) => {
    const { colours } = useTheme();

    return (
        <DropdownMenu.ItemTitle
            {...props}
            style={{
                color: selected ? colours.text.selected : colours.text.primary,
                ...Platform.select({
                    web: {
                        flexGrow: 1,
                        fontFamily: "sans-serif",
                    },
                }),
            }}
        />
    );
}, "ItemTitle");
